import { createActions } from 'redux-actions';

export const { loadAllOrganizations, loadedAllOrganizations, errorAllOrganizations } = createActions(
  'LOAD_ALL_ORGANIZATIONS',
  'LOADED_ALL_ORGANIZATIONS',
  'ERROR_ALL_ORGANIZATIONS',
);
